(function () {
  'use strict';

  if (!window.MANUARTI_DATA) return;

  const D = window.MANUARTI_DATA;
  const TYPE = D.filterType;

  const MA_LANG = (document.documentElement.lang || 'it').slice(0, 2);

  const MA_EN = {
    Provincia: 'Province',
    PROVINCIA: 'PROVINCE',
    Mestiere: 'Craft',
    MESTIERE: 'CRAFT',
    Categoria: 'Category',
    CATEGORIA: 'CATEGORY',
    Famiglia: 'Family',
    FAMIGLIA: 'FAMILY',
    Mercato: 'Market',
    'Ordina per': 'Sort by',
    'ORDINA PER': 'SORT BY',
    'Tutti i mestieri': 'All crafts',
    'Tutte le province': 'All provinces',
    'Tutte le categorie': 'All categories',
    'Tutti i mercati': 'All markets',
    'Sì': 'Yes',
    No: 'No',
    'Alfabetico A → Z': 'Alphabetical A → Z',
    'Alfabetico Z → A': 'Alphabetical Z → A',
    'Per provincia': 'By province',
    'Per mestiere': 'By craft',
    'Per categoria': 'By category',
    'produttore trovato': 'producer found',
    'produttori trovati': 'producers found',
    mestiere: 'craft',
    mestieri: 'crafts',
    'mestiere trovato': 'craft found',
    'mestieri trovati': 'crafts found',
    'Nessun risultato': 'No results',
    'Nessun produttore trovato': 'No producers found',
    'Nessun risultato corrisponde ai filtri': 'No results match the filters',
    'Prova a modificare i criteri di ricerca o a cancellare i filtri attivi.':
      'Try changing your search criteria or clearing the active filters.',
    Cerca: 'Search',
    Filtra: 'Filter',
    'Azzera i filtri': 'Clear filters',
    'Filtri attivi': 'Active filters',
    'Cancella tutti': 'Clear all',
    'Cancella tutti i filtri': 'Clear all filters',
    'CONDIVIDI:': 'SHARE:',
    '📋 Copia link': '📋 Copy link',
    '✓ Copiato!': '✓ Copied!',
    'Manufatti e artigianato': 'Handmade objects and craftsmanship',
    Legno: 'Wood',
    'Tessile e abbigliamento': 'Textiles and clothing',
    Enogastronomia: 'Food and wine',
    Argenteria: 'Silversmithing',
    'Birra artigianale': 'Craft Beer',
    'Bottega alimentare': 'Food Shop',
    'Calzoleria artigianale': 'Artisan Shoemaking',
    Cappelleria: 'Hat Making',
    'Cartotecnica e legatoria': 'Paper Craft and Bookbinding',
    Ceramica: 'Ceramics',
    'Cioccolato e dolciaria': 'Chocolate and Confectionery',
    'Conserve e preparati': 'Preserves and Prepared Foods',
    'Editoria indipendente': 'Independent Publishing',
    'Fabbro e lavorazione metalli': 'Blacksmithing and Metalwork',
    'Falegnameria artistica': 'Artistic Woodworking',
    'Fiori e decorazioni': 'Flowers and Decorations',
    Formaggi: 'Cheese',
    'Lavorazione marmo e pietra': 'Marble and Stone Working',
    'Liquoreria e distillati': 'Liqueurs and Spirits',
    'Miele e apicoltura': 'Honey and Beekeeping',
    Mosaico: 'Mosaic',
    'Olio EVO': 'Extra Virgin Olive Oil',
    Oreficeria: 'Goldsmithing',
    'Pasta e prodotti da forno': 'Pasta and Baked Goods',
    Pelletteria: 'Leathercraft',
    'Restauro e intaglio': 'Restoration and Woodcarving',
    Ricamo: 'Embroidery',
    Salumeria: 'Cured Meats',
    'Sartoria artigianale': 'Artisan Tailoring',
    Terracotta: 'Terracotta',
    Tessitura: 'Weaving',
    Torrefazione: 'Coffee Roasting',
    'Vetro artistico': 'Artistic Glass',
    Vino: 'Wine',
  };

  function t(s) {
    return MA_LANG === 'en' && MA_EN[s] ? MA_EN[s] : s;
  }

  function cardTitle(p) {
    return TYPE === 'mestieri' ? t(p.title) : p.title;
  }

  const MA_LINGUA_PRIMARIA = 'it';
  const MA_ROTTE_INTERNE = ['/pages/', '/collections/', '/blogs/', '/products/'];

  function localizeHref(href) {
    const url = String(href || '');
    if (MA_LANG === MA_LINGUA_PRIMARIA) return url;
    if (!MA_ROTTE_INTERNE.some((rotta) => url.indexOf(rotta) === 0)) return url;
    if (url.indexOf('/' + MA_LANG + '/') === 0) return url;
    return '/' + MA_LANG + url;
  }

  function loadDataForType() {
    if (TYPE === 'mestieri') {
      const blocks = D.mestieriBlocks || [];
      return blocks
        .filter((b) => b && b.title && b.slug)
        .map((b) => ({
          title: b.title,
          url: b.url || '#',
          handle: b.slug,
          image: b.image || null,
          tipo: 'mestiere',
          provincia: null,
          mestiere: b.slug,
          tmh: null,
          mercati: [],
          categoria: b.categoria || null,
        }));
    } else {
      if (!D.pages) return [];
      return D.pages.map(parsePageTags);
    }
  }

  function parsePageTags(page) {
    const meta = {
      title: page.title,
      url: page.url,
      handle: page.handle,
      image: page.image || null,
      tipo: null,
      provincia: null,
      mestiere: null,
      tmh: null,
      mercati: [],
      categoria: null,
    };
    page.tags.forEach((tag) => {
      if (tag.startsWith('tipo:')) meta.tipo = tag.slice(5);
      else if (tag.startsWith('provincia:')) meta.provincia = tag.slice(10);
      else if (tag.startsWith('mestiere:')) meta.mestiere = tag.slice(9);
      else if (tag.startsWith('tmh:')) meta.tmh = tag.slice(4);
      else if (tag.startsWith('mercato:')) meta.mercati.push(tag.slice(8));
      else if (tag.startsWith('categoria:')) meta.categoria = tag.slice(10);
    });
    return meta;
  }

  function slugify(str) {
    return str
      .toLowerCase()
      .replace(/[àáâã]/g, 'a')
      .replace(/[èéê]/g, 'e')
      .replace(/[ìí]/g, 'i')
      .replace(/[òóô]/g, 'o')
      .replace(/[ùú]/g, 'u')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');
  }

  const ALL_PAGES = loadDataForType();

  const state = {
    provincia: [],
    mestiere: '',
    tmh: '',
    mercato: '',
    categoria: '',
    sort: 'alpha-asc',
  };

  function buildFiltersUI() {
    const block = document.getElementById('manuarti-filters-block');
    let html = '<div class="manuarti-filters-container">';

    if (TYPE === 'produttori') {
      html += renderProvincePill();
      html += '<div class="manuarti-filter-row">';
      html += renderMestiereDropdown();
      html += renderTMHPills();
      html += renderSortDropdown(['alpha-asc', 'alpha-desc', 'provincia', 'mestiere']);
      html += '</div>';
    }
    else if (TYPE === 'mestieri') {
      html += renderCategoriaPills();
      html += '<div class="manuarti-filter-row">';
      html += renderSortDropdown(['alpha-asc', 'alpha-desc', 'categoria']);
      html += '</div>';
    }

    html += '</div>';
    block.innerHTML = html;
    attachFilterListeners();
  }

  function renderProvincePill() {
    const slugs = [
      'firenze',
      'prato',
      'pistoia',
      'lucca',
      'massa-carrara',
      'livorno',
      'pisa',
      'siena',
      'arezzo',
      'grosseto',
    ];
    const pills = slugs
      .map(
        (s) => `<button class="manuarti-pill" data-filter="provincia" data-value="${s}">${D.provinceNomi[s]}</button>`,
      )
      .join('');
    return `<div class="manuarti-filter-group">
      <span class="manuarti-filter-label">${t('Provincia')}</span>
      <div class="manuarti-pill-group">${pills}</div>
    </div>`;
  }

  function renderMestiereDropdown() {
    const presenti = new Set();
    ALL_PAGES.forEach((p) => {
      if (p.mestiere) presenti.add(p.mestiere);
    });
    const opts = [`<option value="">${t('Tutti i mestieri')}</option>`];
    Array.from(presenti)
      .sort((a, b) => t(D.mestieriNomi[a] || a).localeCompare(t(D.mestieriNomi[b] || b)))
      .forEach((s) => {
        opts.push(`<option value="${s}">${t(D.mestieriNomi[s] || s)}</option>`);
      });
    return `<div class="manuarti-filter-cell">
      <span class="manuarti-filter-label">${t('Mestiere')}</span>
      <div class="manuarti-dropdown"><select data-filter="mestiere">${opts.join('')}</select></div>
    </div>`;
  }

  function renderTMHPills() {
    return `<div class="manuarti-filter-cell">
      <span class="manuarti-filter-label">TMH</span>
      <div class="manuarti-pill-group">
        <button class="manuarti-pill" data-filter="tmh" data-value="si">${t('Sì')}</button>
        <button class="manuarti-pill" data-filter="tmh" data-value="no">${t('No')}</button>
      </div>
    </div>`;
  }

  function renderCategoriaDropdown() {
    const opts = [`<option value="">${t('Tutte le categorie')}</option>`];
    Object.keys(D.macroCategorieSlug).forEach((slug) => {
      opts.push(`<option value="${slug}">${t(D.macroCategorieSlug[slug])}</option>`);
    });
    return `<div class="manuarti-filter-cell">
      <span class="manuarti-filter-label">${t('Categoria')}</span>
      <div class="manuarti-dropdown"><select data-filter="categoria">${opts.join('')}</select></div>
    </div>`;
  }

  function renderCategoriaPills() {
    const pills = Object.keys(D.macroCategorieSlug)
      .map(
        (slug) =>
          `<button class="manuarti-pill" data-filter="categoria" data-value="${slug}">${t(D.macroCategorieSlug[slug])}</button>`,
      )
      .join('');
    return `<div class="manuarti-filter-group">
      <span class="manuarti-filter-label">${t('Categoria')}</span>
      <div class="manuarti-pill-group">${pills}</div>
    </div>`;
  }

  function renderMercatoDropdown() {
    const presenti = new Set();
    ALL_PAGES.forEach((p) => p.mercati.forEach((m) => presenti.add(m)));
    const opts = [`<option value="">${t('Tutti i mercati')}</option>`];
    Array.from(presenti)
      .sort()
      .forEach((s) => {
        const nome = s
          .split('-')
          .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
          .join(' ');
        opts.push(`<option value="${s}">${nome}</option>`);
      });
    return `<div class="manuarti-filter-cell">
      <span class="manuarti-filter-label">${t('Mercato')}</span>
      <div class="manuarti-dropdown"><select data-filter="mercato">${opts.join('')}</select></div>
    </div>`;
  }

  function renderSortDropdown(opts) {
    const labels = {
      'alpha-asc': 'Alfabetico A → Z',
      'alpha-desc': 'Alfabetico Z → A',
      provincia: 'Per provincia',
      mestiere: 'Per mestiere',
      categoria: 'Per categoria',
    };
    const options = opts.map((o) => `<option value="${o}">${t(labels[o])}</option>`).join('');
    return `<div class="manuarti-filter-cell">
      <span class="manuarti-filter-label">${t('Ordina per')}</span>
      <div class="manuarti-dropdown"><select data-filter="sort">${options}</select></div>
    </div>`;
  }

  function attachFilterListeners() {
    document.querySelectorAll('.manuarti-pill[data-filter]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const f = btn.dataset.filter,
          v = btn.dataset.value;
        if (f === 'provincia') {
          const i = state.provincia.indexOf(v);
          if (i >= 0) state.provincia.splice(i, 1);
          else state.provincia.push(v);
        } else {
          state[f] = state[f] === v ? '' : v;
        }
        applyState();
      });
    });

    document.querySelectorAll('.manuarti-filters-block select[data-filter]').forEach((sel) => {
      sel.addEventListener('change', () => {
        state[sel.dataset.filter] = sel.value;
        applyState();
      });
    });

    sorvegliaScorrimento();
  }

  function sorvegliaScorrimento() {
    document.querySelectorAll('.manuarti-filter-group > .manuarti-pill-group').forEach((riga) => {
      const gruppo = riga.parentElement;
      const segna = function () {
        const resto = riga.scrollWidth - riga.clientWidth;
        const x = riga.scrollLeft;
        gruppo.classList.toggle('ms-scorre-sinistra', resto > 2 && x > 2);
        gruppo.classList.toggle('ms-scorre-destra', resto > 2 && x < resto - 2);
      };
      riga.addEventListener('scroll', segna, { passive: true });
      window.addEventListener('resize', segna, { passive: true });
      segna();
    });
  }

  function readURLState() {
    const u = new URLSearchParams(window.location.search);
    if (u.has('provincia')) state.provincia = u.get('provincia').split(',').filter(Boolean);
    if (u.has('mestiere')) state.mestiere = u.get('mestiere');
    if (u.has('tmh')) state.tmh = u.get('tmh');
    if (u.has('mercato')) state.mercato = u.get('mercato');
    if (u.has('categoria')) state.categoria = u.get('categoria');
    if (u.has('ordina')) state.sort = u.get('ordina');
  }

  function writeURLState() {
    const u = new URLSearchParams();
    if (state.provincia.length) u.set('provincia', state.provincia.join(','));
    if (state.mestiere) u.set('mestiere', state.mestiere);
    if (state.tmh) u.set('tmh', state.tmh);
    if (state.mercato) u.set('mercato', state.mercato);
    if (state.categoria) u.set('categoria', state.categoria);
    if (state.sort && state.sort !== 'alpha-asc') u.set('ordina', state.sort);
    const qs = u.toString();
    const newURL = window.location.pathname + (qs ? '?' + qs : '');
    window.history.replaceState(null, '', newURL);
  }

  function applyState() {
    syncUIWithState();
    const filtered = filterPages();
    const sorted = sortPages(filtered);
    renderGrid(sorted);
    renderActiveChips();
    updateCounter(sorted.length);
    updateShareBar(sorted.length);
    writeURLState();
  }

  function syncUIWithState() {
    document.querySelectorAll('.manuarti-pill[data-filter]').forEach((btn) => {
      const f = btn.dataset.filter,
        v = btn.dataset.value;
      if (f === 'provincia') btn.classList.toggle('active', state.provincia.includes(v));
      else btn.classList.toggle('active', state[f] === v);
    });
    document.querySelectorAll('.manuarti-filters-block select[data-filter]').forEach((sel) => {
      sel.value = state[sel.dataset.filter] || '';
    });
  }

  function filterPages() {
    const expectedTipo = { produttori: 'produttore', mestieri: 'mestiere' }[TYPE];

    return ALL_PAGES.filter((p) => {
      if (expectedTipo && p.tipo !== expectedTipo) return false;
      if (state.provincia.length && !state.provincia.includes(p.provincia)) return false;
      if (state.mestiere && p.mestiere !== state.mestiere) return false;
      if (state.tmh && p.tmh !== state.tmh) return false;
      if (state.mercato && !p.mercati.includes(state.mercato)) return false;
      if (state.categoria && p.categoria !== state.categoria) return false;
      return true;
    });
  }

  function sortPages(arr) {
    const sorted = arr.slice();
    switch (state.sort) {
      case 'alpha-desc':
        sorted.sort((a, b) => cardTitle(b).localeCompare(cardTitle(a)));
        break;
      case 'provincia':
        sorted.sort(
          (a, b) => (a.provincia || '').localeCompare(b.provincia || '') || cardTitle(a).localeCompare(cardTitle(b)),
        );
        break;
      case 'mestiere':
        sorted.sort(
          (a, b) => (a.mestiere || '').localeCompare(b.mestiere || '') || cardTitle(a).localeCompare(cardTitle(b)),
        );
        break;
      case 'categoria':
        sorted.sort(
          (a, b) => (a.categoria || '').localeCompare(b.categoria || '') || cardTitle(a).localeCompare(cardTitle(b)),
        );
        break;
      default:
        sorted.sort((a, b) => cardTitle(a).localeCompare(cardTitle(b)));
    }
    return sorted;
  }

  function renderGrid(pages) {
    const grid = document.getElementById('manuarti-grid');
    const empty = document.getElementById('manuarti-empty-state');

    if (pages.length === 0) {
      grid.style.display = 'none';
      empty.style.display = 'block';
      return;
    }
    grid.style.display = 'grid';
    empty.style.display = 'none';

    grid.classList.add('filtering');
    setTimeout(() => {
      grid.innerHTML = pages.map(renderCard).join('');
      grid.classList.remove('filtering');
    }, 150);
  }

  function renderCard(p) {
    const provNome = p.provincia ? D.provinceNomi[p.provincia] || p.provincia : '';
    let metaPrimary = '',
      metaSecondary = '',
      badge = '';

    if (TYPE === 'produttori') {
      metaPrimary = provNome;
      metaSecondary = p.mestiere ? t(D.mestieriNomi[p.mestiere] || p.mestiere) : '';
      if (p.tmh === 'si') badge = '<span class="manuarti-card-badge">TMH ✓</span>';
    } else if (TYPE === 'mestieri') {
      metaPrimary = p.categoria ? t(D.macroCategorieSlug[p.categoria] || '') : '';
      metaSecondary = '';
    }

    const cardImageHtml = p.image
      ? `<img src="${escapeHtml(p.image)}" alt="${escapeHtml(cardTitle(p))}" class="manuarti-card-image-img" loading="lazy" width="800" height="600">`
      : `<span class="manuarti-card-image-icon">${escapeHtml(shortLabel(cardTitle(p)))}</span>`;

    return `<a href="${localizeHref(p.url)}" class="manuarti-card">
      <div class="manuarti-card-image">
        ${cardImageHtml}
      </div>
      <div class="manuarti-card-body">
        <h2 class="manuarti-card-title">${escapeHtml(cardTitle(p))}</h2>
        <span class="manuarti-card-filetto"></span>
        ${metaPrimary ? `<p class="manuarti-card-meta">${escapeHtml(metaPrimary)}</p>` : ''}
        ${metaSecondary ? `<p class="manuarti-card-meta-secondary">${escapeHtml(metaSecondary)}</p>` : ''}
        ${badge}
      </div>
    </a>`;
  }

  function shortLabel(title) {
    const parole = String(title)
      .split(/[\s·]+/)
      .filter((w) => w && !/^\d+$/.test(w));
    return parole
      .map((w) => w[0])
      .slice(0, 3)
      .join('')
      .toUpperCase();
  }

  function escapeHtml(s) {
    return String(s).replace(
      /[&<>"']/g,
      (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c],
    );
  }

  function renderActiveChips() {
    const block = document.getElementById('manuarti-active-filters');
    const chips = [];

    state.provincia.forEach((slug) => chips.push(makeChip('provincia', slug, D.provinceNomi[slug] || slug)));
    if (state.mestiere)
      chips.push(makeChip('mestiere', state.mestiere, t(D.mestieriNomi[state.mestiere] || state.mestiere)));
    if (state.tmh) chips.push(makeChip('tmh', state.tmh, 'TMH: ' + (state.tmh === 'si' ? t('Sì') : t('No'))));
    if (state.mercato) {
      const nome = state.mercato
        .split('-')
        .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
        .join(' ');
      chips.push(makeChip('mercato', state.mercato, nome));
    }
    if (state.categoria)
      chips.push(makeChip('categoria', state.categoria, t(D.macroCategorieSlug[state.categoria] || state.categoria)));

    if (chips.length === 0) {
      block.style.display = 'none';
      block.innerHTML = '';
      return;
    }

    block.style.display = 'block';
    block.innerHTML = `<div class="manuarti-active-filters-inner">
      <span class="manuarti-active-filters-label">${t('Filtri attivi')}</span>
      ${chips.join('')}
      <button class="manuarti-clear-all" id="manuarti-clear-all">${t('Cancella tutti')}</button>
    </div>`;

    block.querySelectorAll('.manuarti-chip-close').forEach((btn) => {
      btn.addEventListener('click', () => removeChip(btn.dataset.filter, btn.dataset.value));
    });
    document.getElementById('manuarti-clear-all').addEventListener('click', clearAll);
  }

  function makeChip(filter, value, label) {
    return `<span class="manuarti-chip">${escapeHtml(label)} <button class="manuarti-chip-close" data-filter="${filter}" data-value="${value}">✕</button></span>`;
  }

  function removeChip(filter, value) {
    if (filter === 'provincia') {
      state.provincia = state.provincia.filter((p) => p !== value);
    } else {
      state[filter] = '';
    }
    applyState();
  }

  function clearAll() {
    state.provincia = [];
    state.mestiere = '';
    state.tmh = '';
    state.mercato = '';
    state.categoria = '';
    state.sort = 'alpha-asc';
    applyState();
  }

  function updateCounter(n) {
    const el = document.getElementById('manuarti-results-count');
    if (!el) return;
    const hasFilters = state.provincia.length || state.mestiere || state.tmh || state.mercato || state.categoria;
    if (!hasFilters) {
      el.innerHTML = '';
      return;
    }
    let label = '';
    if (TYPE === 'produttori') label = n === 1 ? t('produttore trovato') : t('produttori trovati');
    else if (TYPE === 'mestieri') label = n === 1 ? t('mestiere') : t('mestieri');
    el.innerHTML = `<strong>${n}</strong> ${label}`;
  }

  function updateShareBar(n) {
    const bar = document.getElementById('manuarti-share-bar');
    const hasFilters = state.provincia.length || state.mestiere || state.tmh || state.mercato || state.categoria;
    bar.style.display = hasFilters && n > 0 ? 'flex' : 'none';
  }

  function setupShareButtons() {
    document.querySelectorAll('.manuarti-share-btn').forEach((btn) => {
      btn.addEventListener('click', () => {
        const url = window.location.href;
        const title = document.title;
        const action = btn.dataset.share;
        if (action === 'copy') {
          navigator.clipboard.writeText(url).then(() => {
            const originalText = btn.textContent;
            btn.textContent = t('✓ Copiato!');
            btn.classList.add('copied');
            setTimeout(() => {
              btn.textContent = originalText;
              btn.classList.remove('copied');
            }, 2000);
          });
        } else if (action === 'whatsapp') {
          window.open(`https://wa.me/?text=${encodeURIComponent(title + ' — ' + url)}`, '_blank');
        } else if (action === 'email') {
          window.location.href = `mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(url)}`;
        }
      });
    });
  }

  function setupEmptyButton() {
    const btn = document.getElementById('manuarti-clear-empty');
    if (btn) btn.addEventListener('click', clearAll);
  }

  function localizeStaticLabels() {
    if (MA_LANG !== 'en') return;
    const shareLabel = document.querySelector('.manuarti-share-label');
    if (shareLabel) shareLabel.textContent = t(shareLabel.textContent.trim());
    document.querySelectorAll('.manuarti-share-btn').forEach((btn) => {
      btn.textContent = t(btn.textContent.trim());
    });
    const empty = document.getElementById('manuarti-empty-state');
    if (empty) {
      const titolo = empty.querySelector('h3');
      if (titolo) titolo.textContent = t(titolo.textContent.trim());
      const testo = empty.querySelector('p');
      if (testo) testo.textContent = t(testo.textContent.trim());
      const bottone = empty.querySelector('#manuarti-clear-empty');
      if (bottone) bottone.textContent = t(bottone.textContent.trim());
    }
  }

  function init() {
    readURLState();
    buildFiltersUI();
    setupShareButtons();
    setupEmptyButton();
    localizeStaticLabels();
    applyState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
